import { useState, useContext, useEffect } from "react";
import StateContext from "../../state/stateContext";
import { isAuth } from "../../services/requestServices";
import { Advocacy } from "./Advocacy";
import { ChildAmbassador } from "./ChildAmbassador";
import { MyWvApp } from "./MyWvApp";
import { getNormalizedParams} from "../../helpers/helpers";
import useQueryCommitment from "../Hooks/useQueryCommitment";
import dayjs from "dayjs";

// get a(d) param from querystring
function getAdFromQueryString() {
    const adTypes = ["mywvapp", "childambassador", "advocacy"];
    const adFromQS = getNormalizedParams().get("a"); 

    if (adTypes.includes(adFromQS)) {
        return adFromQS;
    }
    return "";
}

// show child ambassador ad for donors that have sponsored for more than one year. Otherwise show mywvapp.  
function getAdFromDonorStatus(isLoggedIn, yearsSponsored) {
    var ad = "mywvapp"; 

    if(isLoggedIn) {
        if(yearsSponsored > 1) {
            ad = "childambassador";
        }
    }

    return ad;
}

function getAd(isLoggedIn, yearsSponsored) {
    var ad = getAdFromQueryString();

    if(ad === '') {
        ad = getAdFromDonorStatus(isLoggedIn, yearsSponsored);
    }
    return ad;
}

function MoreWv() {

    const context = useContext(StateContext);
    const queryCommitment = useQueryCommitment(context);

    const [logIn, setLogIn] = useState(false);
    const [yearsSponsored, setYearsSponsored] = useState(0);
    useEffect(() => {
      async function setLoggedIn() {
        const isLoggedIn = await isAuth();
        setLogIn(isLoggedIn);
      }
      setLoggedIn();
    }, []);

    useEffect(() => {
        if (queryCommitment.isSuccess) {
            const startDate = queryCommitment.data?.CommitmentStartDate;
            const yearsSponsored = dayjs().diff(startDate, 'year');
            setYearsSponsored(yearsSponsored);
            
            return () => {};
         
        } 
    }, [queryCommitment]);
  

    const ad = getAd(logIn, yearsSponsored);

    switch(ad){
        case ("mywvapp"):
            return <MyWvApp />;

        case ("childambassador"):
            return <ChildAmbassador />;

        case ("advocacy"):
            return <Advocacy />;
        
        default: 
        return <></>;
    } 
}

export default MoreWv; 